module.exports = __webpack_public_path__ + "img/stop.11e99488.svg";